var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "item-edit", staticStyle: { "animation-delay": "2s" } },
    [
      _c("div", { staticClass: "mb-2" }, [
        _vm._v("Bitte gib hier den Code ein:")
      ]),
      _vm._v(" "),
      _c("b-input", {
        ref: "mobilePhoneCodeInput",
        staticClass: "w-auto",
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.confirm.apply(null, arguments)
          }
        },
        model: {
          value: _vm.code,
          callback: function($$v) {
            _vm.code = $$v
          },
          expression: "code"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-4" },
        [
          _c("Button", {
            attrs: {
              text: "Code bestätigen",
              icon: "checkmark",
              loading: _vm.saving,
              disabled: !_vm.codeValid || _vm.saving
            },
            on: { click: _vm.confirm }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mt-4" }, [
        _c("div", [_vm._v("Mobilnummer falsch?")]),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.$emit("change")
                }
              }
            },
            [_vm._v("Hier ändern")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-4" }, [
        _c("div", [_vm._v("Keine SMS bekommen?")]),
        _vm._v(" "),
        _c("div", [
          _vm.sentAgain
            ? _c("div", { staticClass: "success" }, [
                _vm._v("Erfolgreich versendet")
              ])
            : !_vm.saving
            ? _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.resend.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("Hier nochmals senden")]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }